const Paused = () => {
  return (
    <svg
      aria-hidden="true"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1C2 0.446875 1.55313 0 1 0C0.446875 0 0 0.446875 0 1V9C0 9.55312 0.446875 10 1 10C1.55313 10 2 9.55312 2 9V1Z"
        fill="#999999"
      />
      <path
        d="M6 1C6 0.446875 5.55313 0 5 0C4.44687 0 4 0.446875 4 1V9C4 9.55312 4.44687 10 5 10C5.55313 10 6 9.55312 6 9V1Z"
        fill="#999999"
      />
    </svg>
  )
}

export default Paused
